import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './posts.css';

export default function Posts(props) {

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://aiharsoreersu.net/act/files/tag.min.js?z=8718127";
    script.setAttribute("data-cfasync", "false");
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up the script to avoid duplicate injections
      document.body.removeChild(script);
    };
  }, []);

  const [posts, setPosts] = useState([]);
  const collection = props.collect;

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/${collection}`)
      .then((response) => response.json())
      .then((data) => {
        const sortedPosts = data.sort((a, b) => b.views - a.views); 
        setPosts(sortedPosts);
      })
      .catch((error) => console.error('Error fetching posts:', error));
  }, [collection]);

  const navigate = useNavigate();

  const handlepostsClick = (id) => {
    navigate(`/news/${id}/${collection}`);
  };

  const main = { entertainments: 'Entertainment',
    movies: 'Movies',
    sports: 'Sports',
    indianhistory:'Indian History',
    untoldhistory:'Untold History',
    mysteries:'Mysteries',
    india:'India',
    world:'World',
    tech:'Tech',
    lifestyle:'Life Style',
    health:'Health & Wealth'
  };

  return (
    <>
      <section id='posts-section'>
        <div id='posts-cont'>
          <h1>Explore More Articles Regarding {main[collection]}</h1>
          <div id='postarticle'>
            {posts.length > 0 ? (
              posts.map((post, index) => (
                <div key={index} onClick={() => handlepostsClick(post._id)}>
                  {post.thumbnail ? (
                    <>
                      <img src={`data:image/jpeg;base64,${post.thumbnail}`} alt={post.title} />
                    </>
                  ) : (
                    <p>No Thumbnail Available</p>
                  )}
                  <h2>{post.title}</h2>
                </div>
              ))
            ) : (
              <p>Loading posts...</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
